import { QueryClient } from '@tanstack/react-query'

/**
 * Never retry client errors (4xx: 401/403/404/…). They won't succeed on retry, and a forbidden
 * polling query (e.g. a role landing on a page that calls endpoints it can't reach) would otherwise
 * hammer the backend into a refetch storm. Retry only transient failures (network / 5xx), once.
 */
function retryNon4xx(failureCount: number, error: unknown): boolean {
  const status = (error as { response?: { status?: number } })?.response?.status
  if (typeof status === 'number' && status >= 400 && status < 500) return false
  return failureCount < 1
}

/**
 * Singleton QueryClient instance. Exported so that non-React utilities
 * (e.g. formatters.ts) can read from the cache without going through a hook.
 * main.tsx imports this and passes it to <QueryClientProvider>.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: retryNon4xx,
    },
  },
})
